// src/actions/phbrepair.actions.js

import { pbhRepairConstants } from "../constants";
import { alertActions } from "./alert.actions";
import { entityDataGenerator } from "../helpers";

export const pbhRepairsActions = {
  getPBHRepairs,
};

function getPBHRepairs(rowNums, options = {}) {
  return (dispatch) => {
    dispatch(request());
    const getPBHRepairsSummary = entityDataGenerator.genPBHRepairsSummary(
      rowNums,
      options
    );

    getPBHRepairsSummary
      .then((pbhRepairsData) => {
        dispatch(success(pbhRepairsData));
      })
      .catch((err) => {
        dispatch(failure(err.toString()));
        httpErrorHandler(err);
      });
  };

  function request() {
    return { type: pbhRepairConstants.PBH_REPAIRS_REQUEST };
  }
  function success(repairs) {
    return { type: pbhRepairConstants.PBH_REPAIRS_SUCCESS, repairs };
  }
  function failure(error) {
    return { type: pbhRepairConstants.PBH_REPAIRS_FAILURE, error };
  }
}

function httpErrorHandler(error) {
  return (dispatch) => {
    let httpStatus =
      error.response != undefined ? error.response.status : 404;
    if (httpStatus >= 500 || httpStatus == 404) {
      // Added to handle error(s)
      dispatch(alertActions.error("Network Connection Error."));
    } else if (httpStatus == 401) {
      userActions.msalLogout();
      dispatch({ type: userConstants.LOGOUT });
    } else {
      dispatch(failure(error.toString()));
      dispatch(alertActions.error(error.toString()));
    }
  };
}
